import { BehaviorSubject } from 'rxjs';
import { IMenu } from './shared/models/menu';
import { environment } from '@env/environment';

export const menu$ = new BehaviorSubject<IMenu[]>([
  {
    route: "dashboard",
    name: "Dashboard",
    type: "link",
    active: true,
    icon: "home"
  },
  {
    route: "license/in-home-care",
    name: "In Home Care",
    type: "link",
    active: true,
    icon: "home_health"
  },
  {
    route: "license/hemo-tech",
    name: "Hemodialysis Technician",
    type: "link",
    active: environment.displayHemotech,
    icon: "bloodtype"
  },
  {
    route: "license/hospital",
    name: "Hospitals / SICF",
    type: "link",
    active: environment.displayHospitals,
    icon: "local_hospital"
  },
  {
    route: "payments",
    name: "Payments",
    type: "link",
    active: true,
    icon: "attach_money"
  },
  {
    route: "user-management",
    name: "User Management",
    type: "link",
    icon: "manage_accounts",
    roles: ['Admin']
  }
]);
